<template>
  <div>
    <el-card>
      <el-form :inline="true" label-width="120px" size="small">
        <el-row>
          <el-col>
            <el-form-item label="标题">
              <el-input placeholder="请输入标题" v-model="title"></el-input>
            </el-form-item>
            <el-button
              style="margin-left: 15px"
              type="primary"
              size="mini"
              @click="search"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card style="margin-top: 15px">
      <a-tabs type="card" v-model="activeKey">
        <a-tab-pane v-for="(item, index) in type" :key="index">
          <span slot="tab">
            <span @click="changeType(item, index)" style="marginleft: 10px">{{
              item.name
            }}</span>
          </span>
          <el-table
            :data="list"
            :header-cell-style="getRowClass"
            border
            ref="multipleTable"
            style="width: 100%; flex: auto"
            tooltip-effect="light"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              prop="title"
              label="标题"
              align="center"
              width="600"
            ></el-table-column>

            <el-table-column
              align="center"
              class-name="small-padding fixed-width"
              label="操作"
              fixed="right"
            >
              <template slot-scope="{ row }">
                <div class="done">
                  <el-button
                    size="mini"
                    style="width: 90px; margin: 0 0 10px 10px"
                    type="primary"
                    @click="add(row)"
                    >添加</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-row style="width: auto; marginright: 50px; margintop: 20px">
            <el-pagination
              :current-page="currentPage"
              :page-size="pagesize"
              :page-sizes="[5, 10, 15]"
              :total="totalCount"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
            ></el-pagination>
          </el-row>
        </a-tab-pane>
      </a-tabs>
    </el-card>
    <a-modal
      v-model="visible"
      title="添加"
      ok-text="确认"
      cancel-text="取消"
      @ok="hideModal"
    >
      <el-form :inline="true" size="small" ref="formName" :model="addData">
        <el-row>
          <el-checkbox v-model="addData.isRenqi">人气</el-checkbox>
          <el-checkbox v-model="addData.isResou">热搜</el-checkbox>
          <el-checkbox v-model="addData.isKoubei">口碑</el-checkbox>
          <!-- <el-checkbox v-model="checked">备选项</el-checkbox> -->
          <!-- <el-checkbox v-model="checked">备选项</el-checkbox> -->
          <!-- <el-col :span="8">
            <el-form-item label="人气">
              <el-select
                clearable
                placeholder="请选择"
                size="small"
                v-model="addData.isRenqi"
              >
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in messageType"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="热搜">
              <el-select
                clearable
                placeholder="请选择"
                size="small"
                v-model="addData.isResou"
              >
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in messageType"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="口碑">
              <el-select
                clearable
                placeholder="请选择"
                size="small"
                v-model="addData.isKoubei"
              >
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in messageType"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>
    </a-modal>
  </div>
</template>
<script>
import { baseURL } from "../../api/config";
export default {
  props: ["AddData"],
  data() {
    return {
      activeKey: 0,
      loadUpt: false,
      list: [],
      checked1: false,
      pagesize: 10, //每页的个数
      currentPage: 1, //初始页
      totalCount: 0, //分页数量展示，
      current: 0,
      title: "",
      contentType: 1,
      type: [
        {
          name: "新房",
          contentType: "12",
        },
      ],
      //类型--下拉框：
      messageType: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "否",
        },
      ],
      coverImg: "",
      addList: [],
      location: "",
      visible: false,
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
      addData: {
        isResou: "", //热搜
        isRenqi: "", //人气
        isKoubei: "", //口碑
      },
      floorId: "",
    };
  },
  methods: {
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    getList() {
      this.postAxios("/rotation/listAllContentByType", {
        page: {
          pageNum: this.currentPage,
          pageSize: 10,
        },
        q: {
          contentType: 12,
          title: this.title,
        },
      }).then((res) => {
        this.list = res.content;
        this.totalCount = res.totalCount;
      });
    },
    changeType(item, index) {
      this.current = index;
      this.contentType = item.contentType;
      this.getList();
    },
    search() {
      this.getList();
    },
    add(row) {
      this.visible = true;
      this.floorId = row.contentId;
    },
    addBanner(row) {
      this.postAxios("/floorSearch/insert", {
        floorId: this.floorId,
        isResou: Number(this.addData.isResou),
        isRenqi: Number(this.addData.isRenqi),
        isKoubei: Number(this.addData.isKoubei),
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.addData.isResou=0;
          this.addData.isRenqi=0;
          this.addData.isKoubei=0;

        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    hideModal() {
      this.visible = false;
      this.addBanner();
    },
    //分页
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //分页：
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.getList();
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
  mounted() {
    this.location = this.AddData.location;
    this.getList();
  },
  watch: {
    AddData(newVal, oldVal) {
      this.activeKey = 0;
      this.currentPage = 1;
      this.contentType = 1;
      this.location = newVal.obj.location;
      this.getList();
    },
  },
};
</script>
<style scoped lang="less">
.active {
  background: #409eff;
  color: #fff;
}
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 150px;
  height: 150px;
  text-align: center;
  line-height: 145px;
  float: left;
  margin-left: 15px;
}
/deep/ .ant-tabs-bar {
  margin: 0 !important;
}
</style>